const qsBuilder = (queryObject = {}) =>
  Object.entries(queryObject).reduce((queryString, [key, value]) => {
    if (key && value !== undefined && value !== null) {
      if (queryString?.length) {
        queryString = queryString + '&';
      }
      if (Array.isArray(value)) {
        queryString = queryString + `${key}=${value.join(',')}`;
      } else {
        queryString = queryString + `${key}=${value}`;
      }
    }
    return queryString;
  }, '');

export default qsBuilder;
